import { render, staticRenderFns } from "./Submission.vue?vue&type=template&id=da9af25c&scoped=true"
import script from "./Submission.vue?vue&type=script&lang=js"
export * from "./Submission.vue?vue&type=script&lang=js"
import style0 from "./Submission.vue?vue&type=style&index=0&id=da9af25c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da9af25c",
  null
  
)

export default component.exports